import EmptyResult from './EmptyResult'

export * from './EmptyResult'

export default EmptyResult
